// class-transform.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse
} from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { RESPONSE_CLASS } from './http-context-tokens';
import { Page } from '@core/data/model/page';

@Injectable()
export class HttpClassTransformInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const classType = req.context.get(RESPONSE_CLASS);

    return next.handle(req).pipe(
      map(event => {
        if (event instanceof HttpResponse && classType) {
          const body = event.body;

          const isPagedResponse = body &&
            typeof body === 'object' &&
            'totalPages' in body &&
            'totalElements' in body;

          let transformed = body;
          if (isPagedResponse) {
            let content = [];
            if ('content' in body) {
              // @ts-ignore
              content = body.content.map((item: any) => Object.assign(new classType(), item));
            }
            transformed = Object.assign(new Page(), { ...body, content });
          } else if (Array.isArray(body)) {
            // @ts-ignore
            transformed = body.map(item => Object.assign(new classType(), item));
          } else {
            // @ts-ignore
            transformed = Object.assign(new classType(), body);
          }

          return event.clone({ body: transformed });
        }
        return event;
      })
    );
  }
}
